import { useState } from "react";

export const useFormDirty = (form, initialValues) => {
  const [isDirty, setIsDirty] = useState(false);

  const onValuesChange = (values) => {
    setIsDirty(JSON.stringify(values) !== JSON.stringify(initialValues));
  };

  return [isDirty, onValuesChange];
};
